var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,1C7.2,1,0,7.5,0,15.5c0,4.3,2.1,8.3,5.7,11.1L5.9,30c0,0.6,0.4,1.1,0.9,1.4c0.3,0.1,0.5,0.2,0.8,0.2s0.6-0.1,0.8-0.2 l3.4-1.9c1.4,0.3,2.8,0.5,4.2,0.5c8.8,0,16-6.5,16-14.5S24.8,1,16,1z M25.7,13.7l-3.8,5c-1.3,1.8-3.7,2.3-5.7,1.3l-3.6-1.8l-4.5,2.3 c-0.2,0.1-0.4,0.2-0.7,0.2c-0.4,0-0.8-0.2-1.1-0.5c-0.4-0.5-0.5-1.3,0-1.8l3.8-5c1.3-1.8,3.7-2.3,5.7-1.3l3.6,1.8l4.5-2.3 c0.6-0.3,1.3-0.1,1.8,0.4C26.1,12.4,26.1,13.1,25.7,13.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.2ad17cac.svg";
export { ForwardRef as ReactComponent };